/* eslint-disable eqeqeq */
import React from "react";
import PropTypes from "prop-types";
import { IconButton, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import Switch from "@material-ui/core/Switch";

function EditTableRecord(props) {
  // Single source of truth — remove duplicate isActive state
  const [checkedB, setCheckedB] = React.useState(props.isActive == 1);

  const handleChange = async (event) => {
    const checked = event.target.checked;
    const newValue = checked ? 1 : 3;

    // Optimistic update
    setCheckedB(checked);

    try {
      const result = await props.handleChangeStatus(props.recordId, newValue);
      if (result == 0) {
        // Revert on failure
        setCheckedB(!checked);
      }
    } catch (error) {
      // Revert on exception
      setCheckedB(!checked);
    }
  };

  return (
    <div>
      <Tooltip title="Status">
        <Switch
          checked={checkedB}
          onChange={handleChange}
          disabled={props.primaryButtonDisabled || false}
          color="primary"
          name="checkedB"
          inputProps={{ "aria-label": "primary checkbox" }}
        />
      </Tooltip>
      <Tooltip title="Edit">
        <IconButton
          disabled={props.secondaryButtonDisabled || false}
          onClick={() => (window.location = `${props.onEditURL}`)}
        >
          <EditIcon fontSize="small" style={{ color: "#ff9800" }} />
        </IconButton>
      </Tooltip>
    </div>
  );
}

// function EditTableRecord(props) {
//   const [isActive, setIsActive] = React.useState(props.isActive === 1);

//   const isActiveBoolean = props.isActive == 1 ? true : false;
//   const [state, setState] = React.useState({
//     checkedB: isActiveBoolean,
//   });

//   const handleChange = async (event) => {
//     const checked = event.target.checked;

//     const newValue = checked ? 1 : 3;
//     document.getElementById("isActiveInput").value = newValue;
//     setState({ ...state, [event.target.name]: event.target.checked });
//     setIsActive(checked);

//     try {

//       // const result = await props.handleChangeStatus(props.recordId, newValue);
//       let result = await props.handleChangeStatus(props.recordId, newValue);
//       if(result==0){
//         setState({ ...state, [event.target.name]: !event.target.checked });
//         setIsActive(!checked);
//       }

//       // console.log("Status change result:", result);
//     } catch (error) {

//       // console.error("Error changing status:", error);
//     }
//   };

//   return (
//     <div>
//       <form id={"myform" + props.recordId} autoComplete="off">
//         <input type="hidden" value={props.recordId} name="id" />
//         <input
//           type="hidden"
//           id="isActiveInput"
//           value={isActive ? 1 : 3}
//           name="isActive"
//         />
//       </form>

//       <Tooltip title="Status">
//         <Switch
//           checked={state.checkedB}
//           onChange={handleChange}
//           disabled={props.primaryButtonDisabled || false}
//           color="primary"
//           name="checkedB"
//           inputProps={{ "aria-label": "primary checkbox" }}
//         />
//       </Tooltip>
//       <Tooltip title="Edit">
//         <IconButton
//           disabled={props.secondaryButtonDisabled || false}
//           onClick={() => (window.location = `${props.onEditURL}`)}
//           //`#/dashboard/F06Form/${props.recordId}`
//         >
//           <EditIcon fontSize="small" style={{ color: "#ff9800" }} />
//         </IconButton>
//       </Tooltip>
//     </div>
//   );
// }

EditTableRecord.propTypes = {
  primaryButtonDisabled: PropTypes.bool,
  secondaryButtonDisabled: PropTypes.bool,
  onEditURL: PropTypes.any,
  recordId: PropTypes.any,
  isActive: PropTypes.any,
  handleChangeStatus: (fn) => fn,
};

EditTableRecord.defaultProps = {
  primaryButtonDisabled: false,
  secondaryButtonDisabled: false,
  onEditURL: "",
  recordId: "",
  isActive: "",
  handleChangeStatus: (fn) => fn,
};

export default EditTableRecord;
